import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const CopyableIdRoot = styled.span `
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;
const IdText = styled.code `
    background-color: ${colors.black_8};
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    font-size: ${fontSizes.TINY};
`;
const CopyButton = styled.button `
    display: inline-flex;
    align-items: center;
    padding: 2px;
    border: none;
    background: none;
    cursor: pointer;
    color: ${(props) => (props.$copied ? colors.forest_main : colors.black_lighter)};
`;
const CopyIcon = styled(ContentCopyIcon) `
    font-size: ${fontSizes.SMALL} !important;
`;
const CopiedIcon = styled(CheckIcon) `
    font-size: ${fontSizes.SMALL} !important;
`;
export const GlobalAdminCopyableId = ({ value }) => {
    const { t } = useTranslation(["common"]);
    const [copied, setCopied] = React.useState(false);
    const handleCopy = async (event) => {
        event.stopPropagation();
        await navigator.clipboard.writeText(value);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
    };
    return (_jsxs(CopyableIdRoot, { children: [_jsx(IdText, { children: value }), _jsx(CopyButton, { type: "button", "$copied": copied, onClick: handleCopy, "aria-label": copied ? t("Copied") : t("Copy to clipboard"), title: copied ? t("Copied") : t("Copy to clipboard"), children: copied ? _jsx(CopiedIcon, {}) : _jsx(CopyIcon, {}) })] }));
};
